// extracted by mini-css-extract-plugin
export var activeDot = "_24-c";
export var buttonContainer = "_24-9";
export var channelButton = "_24-a";
export var content = "_24-0";
export var contentFull = "_24-2";
export var contentThird = "_24-1";
export var contentWrapper = "_24-7";
export var description = "_24-5";
export var heightShort = "_24-e";
export var image = "_24-3";
export var imageContainer = "_24-4";
export var selectButton = "_24-d";
export var spinnerContainer = "_24-b";
export var titleContent = "_24-8";
export var titleWrapper = "_24-6";